module.exports = __webpack_public_path__ + "img/18.7b38ff85.jpg";